<template>
  <div class="">
    <v-select
      v-model="recipients"
      :options="recipientOptions"
      :clearable="false"
      taggable
      multiple
      :create-option="(text) => ({ label: text, value: text })"
      @input="onChange"
      :disabled="isSelectDisabled"
      append-to-body
    />
  </div>
</template>

<script>
import { ref, onMounted, watch } from "@vue/composition-api";
import { BSpinner } from 'bootstrap-vue'
import vSelect from "vue-select";

export default {
  components: {
    BSpinner,
    vSelect
  },
  props: {
    id: String,
    name: String,
    label: String,
    fieldOptions: Object,
    disabled: {
      type: Boolean,
      default: false,
    },
    field: {
      type: Object,
      default: () => ({}),
    },
    isFormDisabled: {
      type: Boolean,
      default: false
    },
    errors: {
      type: Object,
      default: () => ({}),
    },
    isHorizontal: {
      type: Boolean,
      default: true
    }
  },
  setup(props, { emit }) {
    const recipients = ref(false);
    const recipientOptions = ref([]);
    const isSelectDisabled = ref(false);
    const error = ref(props.errors);

    onMounted(() => {
      isSelectDisabled.value = props.isFormDisabled ?? false;
    });

    watch(
      () => props.isFormDisabled,
      (newValue, oldValue) => {
        isSelectDisabled.value = props.isFormDisabled;
      },
      { immediate: true }
    );

    watch(
      () => props.errors,
      (newValue, oldValue) => {
        error.value = props.errors[props.field.originalName] || null;
      },
      { immediate: true }
    );

    async function onChange(value) {
      emit("updateData", props.field, recipients.value);
    }

    return {
      recipients,
      recipientOptions,
      isSelectDisabled,
      onChange
    }
  }
}
</script>